export const assessmentTemplate = [
  {
    _id: "0007",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "Mmigliuri",
      createdDate: "2022-03-04T00:00:00Z",
      modifiedBy: null,
      modifiedDate: null,
      isActive: true,
    },
    omniData: {
      omniType: "clinicalDementiaRating",
      omniTypeVersion: 1,
      title: "Clincial Dementia Rating (CDR)",
      description:
        "The Clinical Dementia Rating Scale (CDR) is an instrument used in clinical and research settings to assess the severity of Alzheimer disease (AD).  The CDR rates the severity of AD using a 5-point scale that rates the severity of signs and symptoms as they affect the patient’s ability to function in the 6 cognitive categories of memory, orientation, judgment and problem solving, community affairs/ involvement, home life and hobbies, and personal care.",
      duration: "About 5 minutes",
      directions:
        "Select one answer for each question.  Score only as a decline from previous usual level due to cognitive loss, not impairment due to other factors.",
      attribution: "Washington University Alzheimer’s Disease Research Center.",
      validated: true,
      selfAssessment: false,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "CDR1",
          numberText: "1",
          text: "Memory",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Select an answer based on a decline from previous usual level due to cognitive loss, not impairment due to other factors.",
          answerOptions: [
            {
              value: "0",
              text: "None",
              subText: "No memory loss or slight inconsistent forgetfulness",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0.5",
              text: "Questionable",
              subText:
                "Consistent slight forgetfulness; partial recollection of events; 'benign' forgetfulness",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Mild",
              subText:
                "Moderate memory loss; more marked for recent events; defect interferes with everyday activities",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Moderate",
              subText:
                "Severe memory loss; only highly learned material retained; new material lost rapidly",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Severe",
              subText: "Severe memory loss; only fragments remain",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "CDR2",
          numberText: "2",
          text: "Orientation",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Select an answer based on a decline from previous usual level due to cognitive loss, not impairment due to other factors.",
          answerOptions: [
            {
              value: "0",
              text: "None",
              subText: "Fully oriented",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0.5",
              text: "Questionable",
              subText: "Fully oriented except for slight difficulty with time relationships",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Mild",
              subText:
                "Moderate difficulty with time relationships; oriented for place at examination; may have geographic disorientation elsewhere",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Moderate",
              subText:
                "Severe difficulty with time relationships; usually disoriented to time, often to place",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Severe",
              subText: "Oriented to person only",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "CDR3",
          numberText: "3",
          text: "Judgment & Problem Solving",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Select an answer based on a decline from previous usual level due to cognitive loss, not impairment due to other factors.",
          answerOptions: [
            {
              value: "0",
              text: "None",
              subText:
                "Solves everyday problems & handles business & financial affairs well; judgment good in relation to past performance",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0.5",
              text: "Questionable",
              subText: "Slight impairment in solving problems, similarities, and differences",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Mild",
              subText:
                "Moderate difficulty in handling problems, similarities, and differences; social judgment usually maintained",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Moderate",
              subText:
                "Severely impaired in handling problems, similarities, and differences; social judgment usually impaired",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Severe",
              subText: "Unable to make judgments or solve problems",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "CDR4",
          numberText: "4",
          text: "Community Affairs",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Select an answer based on a decline from previous usual level due to cognitive loss, not impairment due to other factors.",
          answerOptions: [
            {
              value: "0",
              text: "None",
              subText:
                "Independent function at usual level in job, shopping, volunteer and social groups",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0.5",
              text: "Questionable",
              subText: "Slight impairment in these activities",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Mild",
              subText:
                "Unable to function independently at these activities although may still be engaged in some; appears normal to casual inspection",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Moderate",
              subText:
                "No pretense of independent function outside home. Appears well enough to be taken to functions outside a family home",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Severe",
              subText:
                "No pretense of independent function outside home. Appears too ill to be taken to functions outside a family home",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "CDR5",
          numberText: "5",
          text: "Home and Hobbies",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Select an answer based on a decline from previous usual level due to cognitive loss, not impairment due to other factors.",
          answerOptions: [
            {
              value: "0",
              text: "None",
              subText: "Life at home, hobbies, and intellectual interests well maintained",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0.5",
              text: "Questionable",
              subText: "Life at home, hobbies, and intellectual interests slightly impaired",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Mild",
              subText:
                "Mild but definite impairment of function at home; more difficult chores abandoned; more complicated hobbies and interests abandoned",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Moderate",
              subText: "Only simple chores preserved; very restricted interests, poorly maintained",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Severe",
              subText: "No significant function in home",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "CDR6",
          numberText: "6",
          text: "Personal Care",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Select an answer based on a decline from previous usual level due to cognitive loss, not impairment due to other factors.",
          answerOptions: [
            {
              value: "0",
              text: "None",
              subText: "Fully capable of self-care",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "1",
              text: "Mild",
              subText: "Needs prompting",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "2",
              text: "Moderate",
              subText: "Requires assistance in dressing, hygiene, keeping of personal effects",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "3",
              text: "Severe",
              subText: "Requires much help with personal care; frequent incontinence",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: {
        finalResult: null,
      },
    },
  },
];

export const assessmentScoring = [
  {
    typeID: "clinicalDementiaRating",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 20,
        formula: null,
        questions: [],
      },
    ],
  },
];
